import React from 'react';

import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import type { ExtranetApprovalAction } from './types';

interface ConfirmActionDialogProps {
  action: ExtranetApprovalAction | null;
  isMutating: boolean;
  onClose: () => void;
  onConfirm: (action: ExtranetApprovalAction) => void;
}

export default function ConfirmActionDialog({ action, isMutating, onClose, onConfirm }: ConfirmActionDialogProps) {
  if (!action) {
    return null;
  }
  const isApprove = action.type === 'approve';
  const label = isApprove ? 'Approve' : 'Reject';
  const count = action.ids.length;

  return (
    <Dialog open onClose={onClose}>
      <DialogTitle>Confirm {isApprove ? 'Approval' : 'Rejection'}</DialogTitle>
      <DialogContent>
        <Typography>
          {label} {count === 1 ? 'this change' : `${count} changes`}?
          {isApprove &&
            ` Approving applies ${count === 1 ? 'this change' : `${count} changes`} to the live listing and records ${
              count === 1 ? 'it' : 'them'
            } as approved.`}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color={isApprove ? 'primary' : 'error'}
          disabled={isMutating}
          onClick={() => onConfirm(action)}
          startIcon={isMutating ? <CircularProgress size={14} /> : undefined}
        >
          {label}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
